import React, { useMemo } from 'react'
import AppContext from 'AppContext'
import { Visits } from './components'
import { hasAccess, featureEnabled, env } from 'components/Helpers'

const MemberDetails = ({ member, match, user }) => {
  const { operator: { id, locales } } = React.useContext(AppContext)
  const token = useMemo(() => window.localStorage.getItem('auth-token'), [])
  const documentEnabled = featureEnabled('documents', id)

  if (!id) {
    return (
      <div className='index memberships' />
    )
  }

  return (
    <div className='box-wrapper'>
      <cl-member-personalia
        apiHost={`https://memberships.${env()}.credlock.net`}
        mountPath={`/operators/${id}/members`}
        operatorid={id}
        token={token}
        id={member.id}
        locales={locales}
      />
      <cl-membership-management
        apiHost={`https://memberships.${env()}.credlock.net`}
        mountPath={`/operators/${id}/members`}
        operatorid={id}
        token={token}
        id={member.id}
      />
      <cl-member-payment-methods
        apiHost={`https://memberships.${env()}.credlock.net`}
        mountPath={`/operators/${id}/members/${member.id}/payment-methods`}
        operatorid={id}
        token={token}
        membershipId={member.id}
      />
      <Visits member={member} />
      {documentEnabled && hasAccess(user, 'memberships.view_documents') && (
        <div className='box'>
          <h2>Documents</h2>
          <cl-membership-documents
            apiHost={`https://memberships.${env()}.credlock.net`}
            mountPath={`/operators/${id}/memberships`}
            operatorid={id}
            token={token}
            membershipId={member.id}
          />
        </div>
      )}
    </div>
  )
}

export default MemberDetails
